import React, { useEffect, useState } from "react";
import BackBtn from "./backBtn";
import AcceptBtn from "./AcceptBtn";
import Popup from "./Popup";
import { PERMISSION_LEVELS, strings } from "../constants";
import { getFamilyPermissions, grantAccess } from "../api";
import {
  checkFamilyPermission,
  getSelectedFamilyToVisitInfo,
} from "../tools/funcs";

const ViewAccessArea = ({ onClose, show, page }) => {
  const [permissions, setPermissions] = useState({});
  const [viewPermissions, setViewPermissions] = useState(new Set());
  const [showPopup, setShowPopup] = useState(false);
  const familyInfo = getSelectedFamilyToVisitInfo();
  const members = familyInfo.members || [];

  async function loadPermissions() {
    const result = await getFamilyPermissions();
    setPermissions(result);
    const selected = new Set();
    members.forEach((member) => {
      if (
        checkFamilyPermission(
          result,
          page.name,
          PERMISSION_LEVELS.VIEW,
          member.memberId
        ) ||
        checkFamilyPermission(
          result,
          page.name,
          PERMISSION_LEVELS.UPLOAD,
          member.memberId
        ) ||
        checkFamilyPermission(
          result,
          page.name,
          PERMISSION_LEVELS.ADMIN,
          member.memberId
        )
      ) {
        selected.add(member.memberId);
      }
    });
    setViewPermissions(selected);
  }

  useEffect(() => {
    if (show) loadPermissions();
  }, [show, page.name]);

  return (
    <div
      className="viewAccessArea"
      style={{ visibility: show ? "visible" : "hidden" }}
    >
      {showPopup && (
        <Popup
          content={strings.DONE_SUCCESSFULLY}
          onClose={() => setShowPopup(false)}
        />
      )}
      <BackBtn onClick={onClose} />
      <div className="membersList">
        {members.map((member) => (
          <label className="member" key={member.memberId}>
            <span>
              {member.firstname} {member.lastname}
            </span>
            <input
              type="checkbox"
              checked={viewPermissions.has(member.memberId)}
              onChange={() => {
                const next = new Set(viewPermissions);
                if (next.has(member.memberId)) next.delete(member.memberId);
                else next.add(member.memberId);
                setViewPermissions(next);
              }}
            />
          </label>
        ))}
      </div>
      <div className="btnArea">
        <AcceptBtn
          width="30%"
          height="30%"
          onClick={async () => {
            await Promise.all(
              members.map(async (member) => {
                const hasView = checkFamilyPermission(
                  permissions,
                  page.name,
                  PERMISSION_LEVELS.VIEW,
                  member.memberId
                );
                const hasHigherAccess =
                  checkFamilyPermission(
                    permissions,
                    page.name,
                    PERMISSION_LEVELS.UPLOAD,
                    member.memberId
                  ) ||
                  checkFamilyPermission(
                    permissions,
                    page.name,
                    PERMISSION_LEVELS.ADMIN,
                    member.memberId
                  );
                const shouldView = viewPermissions.has(member.memberId);
                if (shouldView && !hasView && !hasHigherAccess) {
                  await grantAccess(member.memberId, {
                    [page.name]: PERMISSION_LEVELS.VIEW,
                  });
                } else if (!shouldView && hasView && !hasHigherAccess) {
                  await grantAccess(member.memberId, { [page.name]: null });
                }
              })
            );
            await loadPermissions();
            setShowPopup(true);
          }}
        />
      </div>
    </div>
  );
};

export default ViewAccessArea;
